export const environment = {
  useWindowEnv: false,
  production: false,
  apiUrl: 'https://piwe-stg.smartcode.rocks/api',
  siteUrl: 'https://piwe-stg.smartcode.rocks',
  productServingUrl: 'https://piwe-stg.smartcode.rocks/api',
  wsPayForm: '',
  staticServingUrl: 'https://piwe-stg.smartcode.rocks/api',
};
